import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useEffect } from "react";

const PageNotFound = ({ pageError }) => {
  const history = useHistory();
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  useEffect(() => {
    ManageScroll(history);
  }, [history]);
  return (
    <>
      {hfData?.header && !hfError ? (
        <>
          <Header data={hfData} />
          <div id="primary" className="content-area">
            <section className="error-404 not-found">
              <header className="page-header" style={{ marginBottom: 0 }}>
                {pageError ? (
                  <h1 className="page-title">{pageError}</h1>
                ) : (
                  <h1 className="page-title">
                    Oops! That page can&rsquo;t be found.
                  </h1>
                )}
              </header>
            </section>
          </div>
          <Footer data={hfData} />
        </>
      ) : (
        <h1 className="page-title">Oops! That page can&rsquo;t be found.</h1>
      )}
    </>
  );
};
export default PageNotFound;
